import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { FloatLabel } from "primeng/floatlabel";
import { Textarea } from "primeng/textarea";
import { FormControlBaseDirective } from "../form-control-base.directive";

let nextId = 0;

@Component({
    selector: "kno2-form-textarea",
    imports: [Textarea, FloatLabel, NgTemplateOutlet],
    templateUrl: "./form-textarea.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormTextareaComponent extends FormControlBaseDirective {
    public readonly placeholder = input<string>();
    public readonly inputId = input<string>(`kno2-form-textarea-${nextId++}`);
    public readonly rows = input<number>(3);

    protected readonly value = signal<string>("");

    protected applyValue(value: unknown): void {
        this.value.set((value as string) ?? "");
    }

    protected handleInput(event: Event): void {
        const value = (event.target as HTMLTextAreaElement).value;
        this.value.set(value);
        this.emitChange(value);
    }
}
